import { Component, Input } from '@angular/core';
import { SquareCard } from '@models/square/square-card';
import { PaymentHelper } from '@services/helpers/payment-helper';

@Component({
  selector: 'app-square-card-on-file',
  templateUrl: './square-card-on-file.component.html',
  styleUrls: ['./square-card-on-file.component.less'],
})
export class SquareCardOnFileComponent {
  @Input() card: SquareCard;
  @Input() showSmallBrandLogo: boolean = false;

  PaymentHelper = PaymentHelper;

  constructor() {}
}
